import { Link, useLocation } from 'react-router-dom';
import { Navbar, Container, Nav, NavItem } from 'reactstrap';
import './AdminNavbar.css';
import LanguageSwitcher from '../LanguageSwitcher';

const AdminNavbar = () => {
  const { pathname } = useLocation();

  if (pathname.startsWith('/social')) {
    return null;
  }

  return (
    <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
      <Container fluid className="d-flex align-items-center justify-content-between">
        <Link to="/" className="navbar-brand m-0">
          <img
            alt="TZone Logo"
            src={require('../../assets/img/theme/tzone-logo-450x200.png')}
            style={{ height: '50px' }}
          />
        </Link>

        <Nav className="ml-auto align-items-center" navbar>
          <NavItem>
            <LanguageSwitcher />
          </NavItem>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default AdminNavbar;
